$(() => {
var language = $( "html" ).attr( "lang" );
$( "#area" ).change(function() {
    var powierzchnia = $("#area").val();
    $("#calculator-alert").removeClass().addClass("alert");
    if (powierzchnia && powierzchnia > 0) {
      var paczka = $("#paczka_size").val().replace(",", ".");
      var ilosc_paczek = Math.ceil(powierzchnia / paczka);
      var powierzchnia_z_paczek = (ilosc_paczek * paczka).toFixed(2);
      $('input[name="quantity"]').val(ilosc_paczek);
      var alert_class = "alert-success";
      var alert_text = ilosc_paczek +' '+calculator_positive(ilosc_paczek)+ ' wystarczy na '+powierzchnia_z_paczek+' m<sup>2</sup>';
    } else {
      var alert_class = "alert-warning";
      if(language = "pl-PL") {
        var alert_text = "Wpisz powierzchnię na jaką potrzebujesz płytki";
      } else if(language = "en-US") {
        var alert_text = "Enter the area for which you need the tiles";
      } else if(language = "fr-FR") {
        var alert_text = "Entrez la zone pour laquelle vous avez besoin des tuiles";
      } else if(language = "de-DE") {
        var alert_text = "Geben Sie den Bereich ein, für den Sie die Kacheln benötigen";
      } else if(language = "it-IT") {
        var alert_text = "Inserisci l'area per la quale hai bisogno delle tessere";
      } else if(language = "uk") {
        var alert_text = "Введіть область, для якої вам потрібні плитки";
      }
    }
    $('#calculator-alert').addClass(alert_class).html(alert_text).slideDown();
  });

$( "input[name='quantity']" ).change(function() {

  var ilosc_paczek = $(this).val();

    $("#calculator-alert").removeClass().addClass("alert");

    if (ilosc_paczek && ilosc_paczek > 0) {
      var paczka = $("#paczka_size").val().replace(",", ".");
      var powierzchnia_z_paczek = (ilosc_paczek * paczka).toFixed(2);
      var alert_class = "alert-success";
      var alert_text = ilosc_paczek +' '+calculator_positive(ilosc_paczek)+ ' wystarczy na '+powierzchnia_z_paczek+' m<sup>2</sup>';
    } else {
      var alert_class = "alert-warning";
      var alert_text = "Wpisz powierzchnię na jaką potrzebujesz płytki";
    }
    $('#calculator-alert').addClass(alert_class).html(alert_text).slideDown();
  });
});


function calculator_positive(ilosc_paczek) {
  if(ilosc_paczek == 1) {
    var odmiana = "paczka";
  } else if(
    ilosc_paczek == 11 ||
    ilosc_paczek == 12 ||
    ilosc_paczek == 13 ||
    ilosc_paczek == 14 ||
    (ilosc_paczek%10) == 5 ||
    (ilosc_paczek%10) == 6 ||
    (ilosc_paczek%10) == 7 ||
    (ilosc_paczek%10) == 8 ||
    (ilosc_paczek%10) == 9 ||
    (ilosc_paczek%10) == 0 ||
    (ilosc_paczek%10) == 1
  ) {
    var odmiana = "paczek";
  } else if((ilosc_paczek%10) == 2 || (ilosc_paczek%10) == 3 || (ilosc_paczek%10) == 4) {
    var odmiana = "paczki";
  }
 return odmiana
}
